"use client";

import * as React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const Sun = createSVGIcon(
  <>
    <circle cx="12" cy="12" r="7.25" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 5.33333V0" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 24V18.6667" stroke="currentColor" strokeWidth="1.5" />
    <path d="M18.6667 12L24 12" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M1.19209e-07 12L5.33333 12"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M16.714 7.28588L20.4853 3.51465"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3.51473 20.4854L7.28597 16.7142"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M16.714 16.7141L20.4853 20.4854"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3.51473 3.51457L7.28597 7.28581"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  "Sun",
  { viewBox: "0 0 24 24", fill: "none" }
);
